import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  label,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-6 py-4 text-[15px] sm:text-lg' : 'px-5 py-3.5 text-[14px] sm:text-base';
  return <a href={CHECKOUT_URL} className={`group relative inline-flex w-full max-w-xl items-center justify-center gap-2 rounded-xl bg-gold-500 font-extrabold uppercase leading-tight tracking-wide text-navy-950 shadow-[0_10px_0_-2px_rgba(133,99,28,0.9),0_18px_35px_-12px_rgba(0,0,0,0.55)] transition-[transform,background-color] duration-150 ease-out hover:bg-gold-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-400 active:translate-y-1 active:shadow-[0_5px_0_-2px_rgba(133,99,28,0.9)] ${sizing} ${className}`} data-id="element-113" data-mp="qjsarhixfb8s">
      <span className="text-center" data-id="element-114" data-mp="35xfnf4oip198">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-115" data-mp="35yqtjb5fql3i" />
    </a>;
}